export const referrerUrl = document.referrer.endsWith("/") ? document.referrer.slice(0, -1) : document.referrer;

export enum Domain {
	MAIN = ".cloudpay.net"
}
